import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function editTestAdmin(testAdmin) {
	return fetch(
		`${ENDPOINT_URL}/adminuser/${testAdmin.id}`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(testAdmin),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
